// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3HO1h","notes":"Notes_notes__22Rmh"};